<template>
  <div class="h-full overflow-auto pb-32">
    <!-- <div class="mobile-status-padding"></div> -->
    <!-- Top Navigation Overlay -->
    <div class="fixed top-0 left-0 right-0 z-20 pointer-events-none">
      <div class="mobile-status-padding"></div>

      <div
        class="py-4 px-6 flex justify-between items-center w-full max-w-lg mx-auto pointer-events-auto"
      >
        <button
          class="w-10 h-10 flex items-center justify-center bg-white/90 backdrop-blur-md rounded-full shadow-lg hover:scale-105 active:scale-95 transition-all text-slate-800"
          @click="$emit('close')"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path
              d="M15 19l-7-7 7-7"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div class="flex gap-3">
          <button
            class="w-10 h-10 flex items-center justify-center bg-white/90 backdrop-blur-md rounded-full shadow-lg hover:scale-105 active:scale-95 transition-all"
            @click="toggleFavorite"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              :fill="isFavorite ? '#FF5A5F' : 'none'"
              :stroke="isFavorite ? '#FF5A5F' : 'currentColor'"
              stroke-width="2"
            >
              <path
                d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.72-8.72 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
              />
            </svg>
          </button>
          <button
            class="w-10 h-10 flex items-center justify-center bg-white/90 backdrop-blur-md rounded-full shadow-lg hover:scale-105 active:scale-95 transition-all text-slate-800"
            @click="shareRestaurant"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8M16 6l-4-4-4 4M12 2v13"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Hero Header -->
    <div class="absolute top-0 w-full">
      <div class="mobile-status-padding"></div>
      <div class="relative top-0 w-full py-[35%]"></div>
      <div
      v-if="!restaurantImage"
        class="absolute top-0 left-0 w-full h-full bg-slate-200 shimmer"
      ></div>
      <!-- <ImgComponent
        v-if="restaurantImage"
        :src="restaurantImage"
        class="w-full h-full object-cover absolute top-0 left-0"
        alt="Restaurant Cover"
      /> -->
    </div>

    <div class="sticky top-0">
      <div class="relative">
        <ImgComponent
        v-if="restaurantImage"
        :src="restaurantImage"
        class="w-full h-full object-cover absolute top-0 left-0"
          alt="Restaurant Cover"
        />
        <div class="mobile-status-padding"></div>
        <div class="relative top-0 w-full py-[35%]"></div>
      <div
        class="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-slate-900/60 via-transparent to-transparent"
      ></div>
      </div>
    </div>
    <div class="relative top-0 w-full">
      <div class="absolute -bottom-6 left-6 z-[10]">
        <div
          class="w-24 h-24 rounded-2xl border-4 border-white overflow-hidden bg-white shadow-xl"
        >
          <ImgComponent
            v-if="restaurantData?.logo"
            :src="restaurantData.logo"
            class="w-full h-full object-cover"
            alt="Logo"
          />
          <div
            v-else
            class="w-full h-full bg-white flex items-center justify-center"
          >
            <span
              class="text-5xl font-bold text-primary font-ribeye uppercase"
              >{{ restaurantData?.storeName?.charAt(0) || 'R' }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content Wrapper -->
    <div
      class="bg-white rounded-t-[32px] -mt-8 relative z-[5] min-h-full px-6 pt-16 pb-20"
    >
      <!-- {{restaurantData}} -->

      <!-- Restaurant Title and Basic Info -->
      <div class="mb-6">
        <h1 class="text-3xl font-extrabold text-slate-900 tracking-tight mb-2">
          {{ restaurantData?.storeName || restaurantData?.name }}
        </h1>
        <div
          class="flex flex-wrap items-center gap-4 text-sm text-slate-500 font-medium"
        >
          <div class="flex items-center gap-1">
            <svg
              class="w-4 h-4 text-primary-400 fill-current"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
            <span class="text-slate-900 font-bold">{{
              restaurantData?.statistics?.rating ||
              restaurantData?.rating ||
              '0'
            }}</span>
            <span
              >({{
                restaurantData?.statistics?.ratingCount ||
                restaurantData?.reviewCount ||
                0
              }}
              avis)</span
            >
          </div>
          <div class="w-1 h-1 bg-slate-300 rounded-full"></div>
          <div class="flex items-center gap-1">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" stroke-width="2" />
              <path d="M12 6v6l4 2" stroke-width="2" stroke-linecap="round" />
            </svg>
            <span>{{ restaurantData?.deliverTime || '30-45' }} min</span>
          </div>
          <div
            v-if="restaurantData?.city"
            class="w-1 h-1 bg-slate-300 rounded-full"
          ></div>
          <div v-if="restaurantData?.city" class="flex items-center gap-1">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                stroke-width="2"
              />
              <circle cx="12" cy="10" r="3" stroke-width="2" />
            </svg>
            <span>{{ restaurantData.city }}</span>
          </div>
        </div>

        <div class="mt-3">
          <button
            @click="openReviewDialog"
            class="inline-flex items-center gap-1.5 w-full justify-center text-primary-700 font-bold text-[13px] bg-primary-50 hover:bg-primary-100 border border-primary-200 px-3 py-3 rounded-2xl transition-all"
          >
            <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
            Donner une note
          </button>
        </div>
      </div>

      <!-- Categories Tags -->
      <div class="flex flex-wrap gap-2 mb-6">
        <span
          v-for="(category, index) in restaurantCategories"
          :key="index"
          class="px-4 py-1.5 rounded-full text-xs font-bold bg-slate-100 text-slate-700 uppercase tracking-widest"
        >
          {{ category }}
        </span>
      </div>

      <!-- Promotions Highlight -->
      <div
        v-if="
          restaurantData?.hasPromotion &&
          restaurantData?.activePromotions?.length > 0
        "
        class="mb-8 p-4 bg-primary/5 border border-primary/20 rounded-3xl animate-fadeIn"
      >
        <div class="flex items-center gap-3 mb-4">
          <div
            class="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center text-primary shadow-inner"
          >
            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M5 5a3 3 0 015-2.236A3 3 0 0114.83 6H16a2 2 0 110 4h-5V9a1 1 0 10-2 0v1H4a2 2 0 110-4h1.17C5.06 5.687 5 5.35 5 5zm4 1V5a1 1 0 10-1 1h1zm3 0a1 1 0 10-1-1v1h1z"
                clip-rule="evenodd"
              />
              <path
                d="M9 11H3v5a2 2 0 002 2h4v-7zM11 18h4a2 2 0 002-2v-5h-6v7z"
              />
            </svg>
          </div>
          <h3 class="font-black text-slate-800 tracking-tight italic">
            Offres exceptionnelles
          </h3>
        </div>
        <div class="space-y-3">
          <div
            v-for="promo in restaurantData.activePromotions"
            :key="promo.id"
            @click="showPromotion(promo.id)"
            class="p-4 bg-white/80 backdrop-blur-md rounded-2xl border border-primary/10 shadow-sm flex items-center gap-4 hover:shadow-md hover:scale-[1.02] transition-all cursor-pointer"
          >
            <div
              class="text-primary-600 font-black bg-primary-50 px-3 py-2 rounded-xl text-sm border border-primary/20 min-w-[80px] text-center"
            >
              {{
                promo.discountType === 'percentage'
                  ? '-' + promo.discountValue + '%'
                  : '-' + promo.discountValue + ' F'
              }}
            </div>
            <div class="flex-1 min-w-0">
              <div class="font-bold text-slate-800 truncate">
                {{ promo.name || 'Promotion active' }}
              </div>
              <div class="text-[11px] text-slate-500 mt-0.5 mt-0.5">
                <span
                  v-if="promo.targetType === 'dish'"
                  class="text-primary-600 font-bold mr-2 uppercase tracking-tighter text-[9px]"
                  >Sur les plats</span
                >
                <span
                  v-else-if="promo.targetType === 'category'"
                  class="text-orange-600 font-bold mr-2 uppercase tracking-tighter text-[9px]"
                  >Sur catégorie</span
                >
                Jusqu'au {{ formatDate(promo.validUntil) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs Navigation -->
      <div
        class="flex gap-8 border-b border-slate-100 mb-8 overflow-x-auto no-scrollbar"
      >
        <button
          v-for="tab in ['menu', 'details']"
          :key="tab"
          @click="activeTab = tab"
          class="pb-4 text-sm font-bold uppercase tracking-widest transition-all relative"
          :class="activeTab === tab ? 'text-primary' : 'text-slate-400'"
        >
          {{ tab === 'menu' ? 'Le Menu' : 'À propos' }}
          <div
            v-if="activeTab === tab"
            class="absolute bottom-0 left-0 right-0 h-1 bg-primary rounded-t-full"
          ></div>
        </button>
      </div>

      <div
        class=""
        v-if="restaurantData?.drinks?.length && activeTab === 'menu'"
      >
        <DrinkChoices
          title="Boissons disponibles"
          :restaurantId="restaurantData.id"
          :selectedDrinks="$stores?.cart?.state?.cart?.drinks || []"
          @update:drinks="handleGlobalDrinksUpdate"
        />
      </div>

      <!-- Tab Content: Menu -->
      <div v-if="activeTab === 'menu'" class="space-y-10">
        <!-- Skeleton loading: dishes not yet loaded, waiting for API -->
        <template v-if="dishesData.length === 0 && !menuReady">
          <div class="space-y-4">
            <div
              v-for="i in 4"
              :key="i"
              class="flex gap-4 bg-white rounded-2xl border border-slate-100 overflow-hidden animate-pulse"
            >
              <div class="w-32 h-32 flex-shrink-0 bg-slate-100"></div>
              <div class="flex-1 p-4 flex flex-col justify-between">
                <div class="space-y-2">
                  <div class="h-4 bg-slate-100 rounded-full w-3/4"></div>
                  <div class="h-3 bg-slate-100 rounded-full w-full"></div>
                  <div class="h-3 bg-slate-100 rounded-full w-2/3"></div>
                </div>
                <div class="h-5 bg-slate-100 rounded-full w-1/3"></div>
              </div>
            </div>
          </div>
        </template>

        <!-- Empty state: after 30s delay, dishes still empty -->
        <template v-else-if="dishesData.length === 0 && menuReady">
          <div
            class="flex flex-col items-center justify-center py-16 text-center px-4"
          >
            <h3 class="text-xl font-black text-slate-800 mb-2">
              Menu en cours de préparation
            </h3>
            <p class="text-slate-400 text-sm max-w-[260px] leading-relaxed">
              Ce restaurant est en train de mettre en place son menu. Revenez un
              peu plus tard pour découvrir ses plats !
            </p>
            <button
              @click="$emit('close')"
              class="mt-8 px-8 py-3 bg-primary text-white rounded-full font-bold text-sm shadow-lg shadow-primary/20 hover:scale-105 transition-transform"
            >
              Retour
            </button>
          </div>
        </template>

        <!-- Menu content: dishes are loaded -->
        <template v-else>
          <!-- Category Anchor Nav -->
          <div
            class="sticky top-[80px] z-[10] bg-white/80 backdrop-blur-md py-3 -mx-2 px-2 overflow-x-auto no-scrollbar border-b border-slate-50"
          >
            <div class="flex gap-3">
              <button
                v-for="category in dishCategories"
                :key="category.id"
                @click="scrollToCategory(category.id)"
                class="px-5 py-2 rounded-xl text-xs font-bold whitespace-nowrap transition-all shadow-sm border"
                :class="
                  activeAnchor === category.id
                    ? 'bg-primary border-primary text-white shadow-primary/20'
                    : 'bg-white border-slate-100 text-slate-600 hover:bg-slate-50'
                "
              >
                {{ category.name }}
              </button>
            </div>
          </div>

          <div
            v-for="category in dishCategories"
            :key="category.id"
            :id="'category-' + category.id"
            class="scroll-mt-[150px]"
          >
            <div class="flex items-center gap-3 mb-6">
              <div class="h-6 w-1.5 bg-primary rounded-full"></div>
              <h2
                class="text-xl font-black text-slate-800 tracking-tight italic"
              >
                {{ category.name }}
              </h2>
              <div class="flex-1 h-px bg-slate-100"></div>
            </div>

            <div class="grid grid-cols-1 gap-6">
              <div
                v-for="dish in category.dishes"
                :key="dish.id"
                @click="showDishDetail(dish)"
                class="bg-white rounded-2xl overflow-hidden border border-slate-100 hover:border-primary/30 transition-all hover:shadow-xl hover:shadow-slate-200/50 group flex cursor-pointer backdrop-blur-sm"
              >
                <div
                  class="w-32 h-32 overflow-hidden flex-shrink-0 bg-slate-50"
                >
                  <ImgComponent
                    :src="dish.principalImageUrl || dish.image"
                    class="!object-cover w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    alt="Plat"
                  />
                </div>
                <div class="flex-1 p-4 flex flex-col justify-between min-w-0">
                  <div>
                    <h3
                      class="font-bold text-slate-800 text-lg mb-1 truncate group-hover:text-primary transition-colors"
                    >
                      {{ dish.title || dish.name }}
                    </h3>
                    <p
                      class="text-xs text-slate-400 line-clamp-2 leading-relaxed"
                    >
                      {{
                        dish.description ||
                        'Aucune description disponible pour ce délice.'
                      }}
                    </p>
                  </div>
                  <div class="flex items-center justify-between mt-2">
                    <div class="flex items-center gap-2">
                      <span class="font-black text-slate-900 text-lg">
                        {{
                          Commons.formatNumber(
                            dish.promotion
                              ? dish.promotion.promotionalPrice
                              : dish.price || 0
                          )
                        }}
                        FCFA
                      </span>
                      <span
                        v-if="dish.promotion"
                        class="text-xs text-slate-400 line-through"
                      >
                        {{ Commons.formatNumber(dish.price) }} FCFA
                      </span>
                    </div>
                    <div
                      @click.stop="
                        () => {
                          dish.isDrink
                            ? addDrinkToCart(dish)
                            : addDishToCart(dish);
                        }
                      "
                      class="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all cursor-pointer"
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3"
                      >
                        <path d="M12 5v14M5 12h14" stroke-linecap="round" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- Tab Content: Details -->
      <div v-else-if="activeTab === 'details'" class="animate-fadeIn">
        <!-- Description Card -->
        <div
          v-if="false"
          class="bg-white rounded-3xl p-6 border border-slate-100 shadow-sm mb-8"
        >
          <h3
            class="text-lg font-bold text-slate-900 mb-4 flex items-center gap-2"
          >
            <svg
              class="w-5 h-5 text-primary"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                stroke-width="2"
              />
            </svg>
            L'histoire du restaurant
          </h3>
          <p class="text-slate-600 leading-relaxed italic">
            {{
              restaurantData?.description ||
              "Ce restaurant n'a pas encore ajouté de description détaillée, mais ses plats parlent d'eux-mêmes !"
            }}
          </p>
        </div>

        <!-- Extra Stats Row -->
        <div class="flex items-center gap-3 mb-6 overflow-x-auto no-scrollbar">
          <!-- Vues -->
          <div
            class="flex flex-col items-center justify-center p-3 rounded-2xl bg-slate-50 border border-slate-100 flex-1 min-w-[90px]"
          >
            <div class="flex items-center gap-1.5 text-slate-500 mb-1">
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
              <span class="text-[10px] font-bold uppercase tracking-wider"
                >Vues</span
              >
            </div>
            <span class="font-black text-slate-800 text-sm">{{
              formatTier(restaurantData?.statistics?.views)
            }}</span>
          </div>

          <!-- Commandes -->
          <div
            class="flex flex-col items-center justify-center p-3 rounded-2xl bg-blue-50/50 border border-blue-100 flex-1 min-w-[90px]"
          >
            <div class="flex items-center gap-1.5 text-blue-500 mb-1">
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                />
              </svg>
              <span class="text-[10px] font-bold uppercase tracking-wider"
                >Commandes</span
              >
            </div>
            <span class="font-black text-blue-900 text-sm">{{
              formatTier(restaurantData?.statistics?.ordersCount)
            }}</span>
          </div>

          <!-- Favoris -->
          <div
            class="flex flex-col items-center justify-center p-3 rounded-2xl bg-rose-50/50 border border-rose-100 flex-1 min-w-[90px]"
          >
            <div class="flex items-center gap-1.5 text-rose-500 mb-1">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                />
              </svg>
              <span class="text-[10px] font-bold uppercase tracking-wider"
                >Favoris</span
              >
            </div>
            <span class="font-black text-rose-900 text-sm">{{
              formatTier(restaurantData?.statistics?.favorites)
            }}</span>
          </div>
        </div>

        <!-- Contact & Location Section -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          <!-- Contact Card -->
          <div class="space-y-4" v-if="false">
            <h3 class="text-lg font-bold text-slate-900 mb-2">Suivez-nous</h3>
            <div
              v-if="restaurantData?.phone"
              @click="callRestaurant"
              class="flex items-center gap-4 p-4 bg-white rounded-2xl border border-slate-100 hover:border-primary/50 transition-all cursor-pointer group"
            >
              <div
                class="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center text-green-600 group-hover:bg-green-600 group-hover:text-white transition-all"
              >
                <svg
                  class="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    stroke-width="2"
                  />
                </svg>
              </div>
              <div>
                <div
                  class="text-[10px] text-slate-400 font-black uppercase tracking-widest"
                >
                  Numéro de téléphone
                </div>
                <div class="font-bold text-slate-800">
                  {{ restaurantData.phone }}
                </div>
              </div>
            </div>
            <div
              v-if="restaurantData?.email"
              @click="emailRestaurant"
              class="flex items-center gap-4 p-4 bg-white rounded-2xl border border-slate-100 hover:border-primary/50 transition-all cursor-pointer group"
            >
              <div
                class="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-all"
              >
                <svg
                  class="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    stroke-width="2"
                  />
                </svg>
              </div>
              <div>
                <div
                  class="text-[10px] text-slate-400 font-black uppercase tracking-widest"
                >
                  Email professionnel
                </div>
                <div class="font-bold text-slate-800 truncate max-w-[150px]">
                  {{ restaurantData.email }}
                </div>
              </div>
            </div>
          </div>

          <!-- Location Card -->
          <div class="space-y-4">
            <h3 class="text-lg font-bold text-slate-900 mb-2">Notre adresse</h3>
            <div
              @click="showLocationOnMap"
              class="p-4 bg-white rounded-2xl border border-slate-100 hover:border-primary/50 transition-all cursor-pointer group"
            >
              <div class="flex items-center gap-4 mb-4">
                <div
                  class="w-12 h-12 bg-primary-50 rounded-xl flex items-center justify-center text-primary-600 group-hover:bg-primary-600 group-hover:text-white transition-all"
                >
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      stroke-width="2"
                    />
                    <path
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      stroke-width="2"
                    />
                  </svg>
                </div>
                <div class="flex-1 min-w-0">
                  <div
                    class="text-[10px] text-slate-400 font-black uppercase tracking-widest"
                  >
                    Emplacement
                  </div>
                  <div class="font-bold text-slate-800 line-clamp-1">
                    {{ formattedAddress }}
                  </div>
                </div>
              </div>
              <div
                class="w-full h-32 bg-slate-100 rounded-xl relative overflow-hidden"
              >
                <!-- Fake Map Placeholder replaced with real static map -->
                <ImgComponent
                  :src="`https://maps.googleapis.com/maps/api/staticmap?center=${restaurantData?.lat},${restaurantData?.lng}&zoom=14&size=400x200&key=${constants.GOOGLE_MAP.GOOGLE_MAP_API_KEY}`"
                  class="w-full h-full object-cover"
                  alt="Map"
                />
                <div class="absolute inset-0 flex items-center justify-center">
                  <button
                    class="px-4 py-2 bg-slate-900 text-white text-xs font-black rounded-lg shadow-xl shadow-black/20"
                  >
                    VOIR SUR LA CARTE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Social Media Row -->
        <div v-if="hasSocialLinks" class="mb-10">
          <h3 class="text-lg font-bold text-slate-900 mb-4">Suivez-nous</h3>
          <div class="flex gap-4">
            <a
              v-if="restaurantData?.facebookLink"
              :href="restaurantData.facebookLink"
              target="_blank"
              class="w-12 h-12 flex items-center justify-center bg-blue-50 text-blue-600 rounded-2xl hover:bg-blue-600 hover:text-white transition-all"
            >
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"
                />
              </svg>
            </a>
            <a
              v-if="restaurantData?.instagramLink"
              :href="restaurantData.instagramLink"
              target="_blank"
              class="w-12 h-12 flex items-center justify-center bg-pink-50 text-pink-600 rounded-2xl hover:bg-pink-600 hover:text-white transition-all"
            >
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M7 2a5 5 0 00-5 5v10a5 5 0 005 5h10a5 5 0 005-5V7a5 5 0 00-5-5H7zm10.5 3.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM12 7a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z"
                />
              </svg>
            </a>
            <a
              v-if="restaurantData?.whatsappNumberHelp"
              :href="`https://wa.me/${restaurantData.whatsappNumberHelp}`"
              target="_blank"
              class="w-12 h-12 flex items-center justify-center bg-green-50 text-green-600 rounded-2xl hover:bg-green-600 hover:text-white transition-all"
            >
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M12 2C6.477 2 2 6.477 2 12c0 1.891.524 3.655 1.438 5.162L2 22l4.908-1.308A9.957 9.957 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 2c4.418 0 8 3.582 8 8s-3.582 8-8 8a7.95 7.95 0 01-4.24-1.226l-.304-.178-2.923.779.791-2.951-.194-.316A7.957 7.957 0 014 12c0-4.418 3.582-8 8-8zm-1.5 3c-.276 0-.5.224-.5.5v2c0 .276.224.5.5.5h2c.276 0 .5-.224.5-.5v-2c0-.276-.224-.5-.5-.5h-2z"
                />
              </svg>
            </a>
          </div>
        </div>

        <!-- Opening Hours Detailed -->
        <div
          class="bg-white rounded-3xl p-6 border border-slate-100 shadow-sm mb-10 overflow-hidden"
        >
          <h3
            class="text-xl font-extrabold text-slate-900 mb-6 flex items-center gap-3"
          >
            <div
              class="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center text-primary"
            >
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 8v4l3 1.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  stroke-width="2"
                />
              </svg>
            </div>
            Heures de service
          </h3>
          <div class="space-y-4">
            <div
              v-for="(day, key) in openingHoursArray"
              :key="key"
              class="flex items-center justify-between p-3 rounded-2xl transition-all"
              :class="
                isToday(day.key) ? 'bg-primary/5 border border-primary/10' : ''
              "
            >
              <div class="flex items-center gap-3">
                <span
                  class="text-sm font-black uppercase tracking-widest"
                  :class="isToday(day.key) ? 'text-primary' : 'text-slate-400'"
                >
                  {{ day.name }}
                </span>
                <span
                  v-if="isToday(day.key)"
                  class="px-2 py-0.5 bg-primary text-white text-[8px] font-black rounded-full uppercase"
                  >Today</span
                >
              </div>
              <div v-if="day.opened" class="flex flex-col items-end">
                <div class="text-sm font-bold text-slate-800">
                  {{ day.lunch }}
                </div>
                <div v-if="day.dinner" class="text-xs text-slate-400">
                  {{ day.dinner }}
                </div>
              </div>
              <div
                v-else
                class="text-sm font-bold text-red-400 uppercase tracking-widest"
              >
                Fermé
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Map Dialog -->
    <DialogComponent
      ref="mapDialog"
      type="fullscreen"
      noInnerPadding
      hideCloseButton
    >
      <div class="h-full w-full relative bg-slate-50 flex flex-col">
        <div
          class="absolute top-0 left-0 right-0 z-10 flex items-center p-4 pointer-events-none"
        >
          <div class="mobile-status-padding w-full absolute top-0"></div>
          <button
            class="w-10 h-10 flex items-center justify-center bg-white/90 backdrop-blur-md rounded-full shadow-lg text-slate-800 relative z-20 mt-8 pointer-events-auto"
            @click="closeMapDialog"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path
                d="M15 19l-7-7 7-7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <MapComponent
          ref="mapRef"
          @ready="centerMapOnRestaurant"
          class="flex-1 w-full"
        />
      </div>
    </DialogComponent>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';
import ImgComponent from '@ui/core/img/ImgComponent.global.vue';
import Commons from '@features/shared/libraries/commons';
import MapComponent from '@features/map/Map.vue';

const { proxy } = getCurrentInstance();
const { $constants } = proxy;

const props = defineProps({
  restaurantData: {
    type: Object,
    required: true
  },
  dishesData: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['close']);

// State
const activeTab = ref('menu');
const activeAnchor = ref('all');
const expandedItems = ref({});
const menuReady = ref(false); // becomes true after 30s delay

const mapDialog = ref(null);
const mapRef = ref(null);

// Computed properties
const formatTier = (val) => {
  const value = parseInt(val) || 0;
  if (value >= 5000) return '5k+';
  if (value >= 1000) return '1k+';
  if (value >= 500) return '500+';
  if (value >= 200) return '200+';
  if (value >= 100) return '100+';
  if (value >= 15) return '15 à 100';
  if (value > 0) return '1 à 15';
  return '0';
};
const restaurantImage = computed(() => {
  return (
    props.restaurantData?.images?.[0] ||
    props.restaurantData?.coverImage ||
    '/images/restaurant.webp'
  );
});

const isFavorite = computed(() => {
  const favoriteRestaurants =
    window.$stores?.user?.state?.current?.favoriteRestaurants || [];
  return favoriteRestaurants.includes(props.restaurantData?.id);
});

const restaurantCategories = computed(() => {
  const cats = props.restaurantData?.categories || [];
  const tags = props.restaurantData?.tags || [];
  // Combine unique values
  return [...new Set([...cats, ...tags])];
});

const hasSocialLinks = computed(() => {
  return (
    props.restaurantData?.facebookLink ||
    props.restaurantData?.instagramLink ||
    props.restaurantData?.whatsappNumberHelp
  );
});

const openingHoursArray = computed(() => {
  if (!props.restaurantData?.openingHours) return [];

  const days = [
    { key: 'monday', name: 'Lundi' },
    { key: 'tuesday', name: 'Mardi' },
    { key: 'wednesday', name: 'Mercredi' },
    { key: 'thursday', name: 'Jeudi' },
    { key: 'friday', name: 'Vendredi' },
    { key: 'saturday', name: 'Samedi' },
    { key: 'sunday', name: 'Dimanche' }
  ];

  return days.map((day) => ({
    ...day,
    ...props.restaurantData.openingHours[day.key]
  }));
});

const dishCategories = computed(() => {
  const categories = new Map();

  // "Tous" category
  categories.set('all', {
    id: 'all',
    name: 'Tous les délices',
    dishes: props.dishesData
  });

  // Group dishes by category
  props.dishesData.forEach((dish) => {
    const categoryId = dish.categoryId || 'other';
    const categoryName = dish.category || 'Autres';

    if (!categories.has(categoryId)) {
      categories.set(categoryId, {
        id: categoryId,
        name: categoryName,
        dishes: []
      });
    }
    categories.get(categoryId).dishes.push(dish);
  });

  // Add Drinks category if exists in restaurantData
  // if (props.restaurantData?.drinks?.length > 0) {
  //   const drinksAsDishes = props.restaurantData.drinks.map((drink) => ({
  //     id: drink.id,
  //     title: drink.name,
  //     price: drink.amount,
  //     principalImageUrl: drink.image,
  //     description: 'Boisson rafraîchissante',
  //     categoryId: 'drinks',
  //     category: 'Boissons',
  //     isDrink: true
  //   }));

  //   categories.set('drinks', {
  //     id: 'drinks',
  //     name: 'Boissons',
  //     dishes: drinksAsDishes
  //   });

  //   // Also update "All" category
  //   categories.get('all').dishes = [
  //     ...categories.get('all').dishes,
  //     ...drinksAsDishes
  //   ];
  // }

  return Array.from(categories.values()).filter((cat) => cat.dishes.length > 0);
});

const formattedAddress = computed(() => {
  const addr = props.restaurantData?.address;
  if (!addr) return 'Adresse non spécifiée';
  if (typeof addr === 'string') return addr;
  if (typeof addr === 'object') {
    return (
      `${addr.street || ''} ${addr.area || ''} ${addr.city || ''} ${addr.country || ''}`.trim() ||
      'Adresse non spécifiée'
    );
  }
  return 'Adresse non spécifiée';
});

// Use store values for cart summary if available
const cartItemCount = computed(
  () => window.$stores?.cart?.state?.cart?.totalQuantity || 0
);
const cartTotal = computed(() => window.$stores?.cart?.state?.cart?.total || 0);

// Methods
const isToday = (dayKey) => {
  const days = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
  ];
  const todayIndex = new Date().getDay();
  return days[todayIndex] === dayKey;
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long'
  });
};

const callRestaurant = () => {
  if (props.restaurantData?.phone) {
    window.location.href = `tel:${props.restaurantData.phone}`;
  }
};

const emailRestaurant = () => {
  if (props.restaurantData?.email) {
    window.location.href = `mailto:${props.restaurantData.email}`;
  }
};

const shareRestaurant = () => {
  bus.emit(
    constants.EVENTS?.SHARER?.RESTAU?.SHOW || 'sharer.restau.show',
    props.restaurantData
  );
};

const showLocationOnMap = () => {
  console.log(
    '🚀 ~ showLocationOnMap ~ props.restaurantData:',
    props.restaurantData
  );
  if (props.restaurantData?.lat && props.restaurantData?.lng) {
    mapDialog.value?.show();
    setTimeout(() => {
      centerMapOnRestaurant();
    }, 500);
  }
};

const closeMapDialog = () => {
  mapDialog.value?.hide();
};

const centerMapOnRestaurant = () => {
  if (props.restaurantData?.lat && props.restaurantData?.lng && mapRef.value) {
    const pos = {
      lat: Number(props.restaurantData.lat),
      lng: Number(props.restaurantData.lng)
    };
    mapRef.value.centerOnPosition(pos);
    mapRef.value.setMarker(
      {
        position: pos,
        content: props.restaurantData.storeName || 'Restaurant',
        iconType: 'restaurant'
      },
      'restaurant',
      'rest-1'
    );
  }
};

const scrollToCategory = (categoryId) => {
  activeAnchor.value = categoryId;
  const element = document.getElementById('category-' + categoryId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const showDishDetail = (dish) => {
  bus.emit('dish.SHOW_DISH_DETAIL', {
    id: dish.id
  });
};

const addDishToCart = (dish) => {
  if (!dish || !dish.id) {
    console.error('Invalid item for adding to cart');
    return;
  }

  bus.emit(constants.EVENTS.CART.ITEMS.ADD, {
    restaurantId: props.restaurantData.id,
    restaurant: props.restaurantData,
    restaurantName:
      props.restaurantData.name ||
      props.restaurantData.storeName ||
      'Restaurant',
    dishId: dish.id,
    title: dish.title,
    name: dish.title,
    price: dish.promotion ? dish.promotion.promotionalPrice : dish.price,
    originalPrice: dish.promotion ? dish.price : undefined,
    promotion: dish.promotion || undefined,
    quantity: 1,
    currency: dish.currency || 'XOF',
    description: dish.description,
    category: dish.category,
    categoryId: dish.categoryId,
    principalImageUrl: dish.principalImageUrl || dish.image,
    options: [],
    drinks: [],
    fullOptions: dish.options,
    fullAccompaniments: dish.accompaniments
  });
};

const showCart = () => {
  bus.emit(constants.EVENTS.CART.SHOW);
};

const showPromotion = (id) => {
  bus.emit(constants.EVENTS.DEALS.SHOW_DETAIL, { id });
};

const toggleFavorite = () => {
  if (!props.restaurantData?.id) return;
  bus.emit($constants.EVENTS.USER.FAVORITE_TOGGLE_REST, {
    restaurantId: props.restaurantData.id,
    isFavorite: isFavorite.value
  });
};

const openReviewDialog = () => {
  if (!props.restaurantData) return;
  bus.emit($constants.EVENTS.RESTAURANT.REVIEW_REQUIRED, props.restaurantData);
};

onMounted(() => {
  // Track restaurant view
  if (props.restaurantData?.id) {
    bus.emit($constants.EVENTS.RESTAURANT.UPDATE_STATS_REQUESTED, {
      restaurantId: props.restaurantData.id,
      action: 'incrementViews',
      value: 1
    });
  }

  // Show empty-menu state only after 30s (gives time for API to respond)
  setTimeout(() => {
    menuReady.value = true;
  }, 2000);

  // Simple intersection observer to update active category on scroll
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activeAnchor.value = entry.target.id.replace('category-', '');
        }
      });
    },
    { threshold: 0.5, rootMargin: '-150px 0px 0px 0px' }
  );

  dishCategories.value.forEach((cat) => {
    const el = document.getElementById('category-' + cat.id);
    if (el) observer.observe(el);
  });
});
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.shimmer {
  background: linear-gradient(90deg, #f1f5f9 25%, #f8fafc 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.4s ease-out forwards;
}
</style>
